export default "__VITE_ASSET__CabZgKlX__"